export const cusip6From9 = (cusip9: string) => cusip9.substring(0, 6);


export const emmaCusipActivityUrl = (cusip: string): string =>
  // eslint-disable-next-line no-restricted-syntax
  `https://emma.msrb.org/Security/Details/${cusip}?tab=tabTradeActivity`;
